/**
 * Connection status indicator component
 */
export const ConnectionStatus = ({ wsConnected, reconnecting }) => {
  return (
    <>
      {/* Reconnecting indicator */}
      {!wsConnected && reconnecting && (
        <div className="fixed top-16 left-1/2 transform -translate-x-1/2 bg-yellow-500 text-white px-4 py-2 rounded-full shadow-lg z-50 animate-pulse">
          <div className="flex items-center gap-2">
            <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white"></div>
            <span className="text-sm font-medium">Reconnecting...</span>
          </div>
        </div>
      )}
      
      {/* Connected indicator */}
      {wsConnected && (
        <div className="fixed bottom-20 md:bottom-4 right-4 text-xs text-gray-600 dark:text-gray-400 flex items-center gap-1 bg-white dark:bg-gray-800 px-2 py-1 rounded-full shadow-sm z-30">
          <div className="w-2 h-2 bg-green-500 rounded-full animate-pulse"></div>
          <span>Connected</span>
        </div>
      )}
    </>
  );
};

export default ConnectionStatus;
